import React from "react";
import './BurgerMenu.css'

const BurgerMenu = ({isOpen}) => {
    return (
        <div className='burger-menu'>
            <div className={`burger ${isOpen ? 'burger1' : ""}`}></div>
            <div className={`burger ${isOpen ? 'burger2' : ""}`}></div>
            <div className={`burger ${isOpen ? 'burger3' : ""}`}></div>
        </div>
    )
}

export default BurgerMenu;